import React from 'react'
import style from './style.module.scss'
import iplIcon from '@assets/images/ipl/IPLIcon.svg'
import MyImage from '@shared/components/myImage'
import CustomLink from '@shared/components/customLink'

function IPLHeader() {
  return (<div className='absolute'>
    <div className={style.chessHeader}>
      <div className={style.mainTitle}>
        <div className="d-flex gap-4 align-items-center w-100 px-3" style={{ paddingRight: '2rem' }}>
          <div className={style.iplIconWrapper}>
            <MyImage src={iplIcon} alt='Tata IPL 2025' title='Tata IPL 2025' />
          </div>
          <div className={`${style.date} d-md-flex flex-column d-none`}>
            <p>22 March - 3 June 2025</p>
          </div>
        </div>
      </div>
      <div className={`${style.date} d-md-none mt-4`}>
        <p>22 March - 3 June 2025</p>
      </div>
    </div>
    <header className={style.header}>
      <nav className={style.nav}>
        {['Home', 'Fixtures', 'Teams', 'Stats', 'News', 'Videos'].map((item) => (
          <CustomLink key={item} href={
            item === 'Home' ? '/cricket/series/indian-premier-league-2025' : `/cricket/series/indian-premier-league-2025/${item.toLowerCase()}`
          } >
            <a>

            <span className={style.link}>{item}</span>
            </a>
          </CustomLink>
        ))}
      </nav>
    </header>
  </div>
  )
}

export default IPLHeader
